<script>
import ValueComboBox from './ValueComboBox'

export default {
  name: 'BidStrategyComboBox',
  components: {
    ValueComboBox
  },
  computed: {
    items() {
      return [
        { value: 'COST_CAP', text: 'Cost Cap' },
        { value: 'LOWEST_COST_WITH_BID_CAP', text: 'Lowest Cost With Bid Cap' },
        { value: 'LOWEST_COST_WITHOUT_CAP', text: 'Lowest Cost Without Cap' },
        { value: 'TARGET_COST', text: 'Target Cost' }
      ]
    }
  }
}
</script>

<template>
  <value-combo-box @input="$emit('input', $event)" :items="items" label="Bid strategy" v-bind="$attrs" />
</template>
